/*This page will be about showing the current membership level option to upgrade or cancel*/
import React, {useState, useCallback} from 'react';
import AccountSetupStepper from "../components/AccountSetupStepper";
import MembershipOptionCard from "../components/MembershipOptionCard";
import {getSubscriptions} from "../Services/VenueService.ts";


const Membership = () => {
    const [currentVenueKey, setCurrentVenueKey] = useState("");
    const [membershipLevel, setMembershipLevel] = React.useState('');
    const [membershipCompleteText, setMembershipComplete] = React.useState('Please Select Membership Level');
    const handleChange = (event) => {
        setMembershipLevel(event.target.value);

        const selectedLevel = event.target.value;
        setMembershipLevel(selectedLevel);
        if (selectedLevel === 'payg') {
            setMembershipComplete('Complete Membership');
        } else {
            setMembershipComplete('Pay and Complete Membership');
        }
    };

    const [subscriptions, setSubscriptions] = useState([]);

    const fetchSubscriptions =  useCallback(async () => {
        if (currentVenueKey) {
            let subResultData = await getSubscriptions(currentVenueKey);

            if (subResultData && subResultData.items.length > 0) {
                setSubscriptions(subResultData.items);
            } else {
                setCurrentVenueKey("");
                setSubscriptions([]);
            }
        }
    }, [currentVenueKey]);

    fetchSubscriptions();
    
    return (
        <div className="min-h-screen bg-black flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl w-full space-y-8">
                <AccountSetupStepper currentStep={4}/>
                
                <div className="card p-8">
                    <h1 className="text-3xl font-bold text-white mb-6">Membership</h1>
                    
                    <div className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">
                                Membership Level
                            </label>
                            <select
                                value={membershipLevel}
                                onChange={handleChange}
                                className="input-field"
                            >
                                <option value="">Select membership level...</option>
                                {subscriptions.map((sub) => (
                                    <option key={sub.id} value={`level-${sub.id}`}>
                                        {sub.name} - {sub.tokensPerCycle} tokens per cycle (£{sub.cost})
                                    </option>
                                ))}
                                <option value="payg">Pay As You Go</option>
                            </select>
                        </div>
                        
                        <MembershipOptionCard membershipLevel={membershipLevel}/>
                        
                        <button className="btn-primary w-full">
                            {membershipCompleteText}
                        </button>
                        
                        <div className="text-center">
                            <p className="text-sm text-gray-400">
                                Payment processing powered by GoCardless
                            </p>
                            <a 
                                href="https://developer.gocardless.com/direct-debit/taking-subscription-payments" 
                                className="text-blue-400 hover:text-blue-300 text-xs"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Learn more about our payment system
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Membership;